module.exports = __webpack_public_path__ + "static/media/bg7m.23dcfb51.jpg";